import React, {useMemo} from 'react';
import {Typography} from '@fupa/fupa-uikit';
import {Information, Container} from 'app/components/match/matchLive/LivetickerCommon';
import {LoadingButton} from '@mui/lab';
import {getTimePeriodAsString} from 'app/helpers/dateHelpers';
import {captureSentryException} from 'app/services/sentryLogging';

const LivetickerAvailableInX = ({assignAtTimestamp}) => {
  const timeUntilAvailable = useMemo(() => getTimePeriodAsString(new Date(assignAtTimestamp)), [assignAtTimestamp]);

  if (!timeUntilAvailable) {
    captureSentryException(new Error('LivetickerAvailableInX: timeUntilAvailable is null'), {
      extra: {assignAtTimestamp},
    });
    return null;
  }

  return (
    <Container>
      <Information>
        <Typography variant='body1'>Übernehme als Liveticker-Melder in {timeUntilAvailable}. ⏰</Typography>
      </Information>
      <LoadingButton disabled={true} variant='contained' color='secondary'>
        Liveticker übernehmen
      </LoadingButton>
    </Container>
  );
};

export default LivetickerAvailableInX;
